import React from 'react';
import styled from 'styled-components';
import { Button } from 'components';
import { LeftArrow } from 'assets/svgs/';

function LeftButton({ onClick, disabled, style }) {
  return (
    <StyledButton
      aria-label="Previous slide"
      title="Previous slide"
      style={{
        height: '2.5rem',
        minWidth: 'unset',
        padding: 'unset',
        paddingRight: '0.188rem',
        width: '2.5rem',
        ...style
      }}
      onClick={onClick}
      disabled={disabled}>
      <LeftArrow alt="left arrow" width="15" />
    </StyledButton>
  );
}

const StyledButton = styled(
  React.forwardRef((props, ref) => <Button {...props} innerRef={ref} />)
)``;

export default LeftButton;
